import {hasLogin} from '@/services/auth'
import Router from 'vue-router'

let router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: {name: 'orders', query: {status: 'not_finished'}} },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: 'orders' */'@/components/Login'),
      meta: {
        auth: false
      }
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import(/* webpackChunkName: 'orders' */'@/components/Orders')
    },
    {
      path: '/orders/:order_no',
      name: 'order',
      component: () => import(/* webpackChunkName: 'orders' */'@/components/Order')
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: () => import(/* webpackChunkName: 'orders' */'@/components/Tasks')
    },
    {
      path: '/tasks/:task_id',
      name: 'task',
      component: () => import(/* webpackChunkName: 'orders' */'@/components/Task')
    },
    {
      path: '/order_loggers',
      name: 'order-logs',
      component: () => import('@/components/OrderLogs')
    },
    {
      path: '/main_products',
      name: 'mainProducts',
      component: () => import('@/components/MainProducts')
    },
    {
      path: '/companies',
      name: 'companies',
      component: () => import('@/components/Companies')
    },
    {
      path: '/companies/:companyCode/users',
      name: 'company-users',
      component: () => import('@/components/CompanyUsers')
    },
    {
      path: '/operation',
      name: 'operation',
      component: () => import('@/components/Operation')
    },
    {
      path: '/aftersales',
      name: 'after-sales',
      component: () => import('@/components/AfterSales')
    },
    {
      path: '/materials',
      name: 'materials',
      component: () => import('@/components/Materials')
    },
    {
      path: '/materials/:mid',
      name: 'material',
      component: () => import('@/components/Material')
    },
    {
      path: '/help',
      component: () => import(/* webpackChunkName: 'help' */'@/components/Help'),
      children: [{
        path: '/',
        component: () => import(/* webpackChunkName: 'help' */'@/components/_help/HelpIndex')
      }, {
        path: 'search-orders',
        component: () => import(/* webpackChunkName: 'help' */'@/components/_help/HelpSearchOrders')
      }, {
        path: 'manage-orders',
        component: () => import(/* webpackChunkName: 'help' */'@/components/_help/HelpManageOrders')
      }, {
        path: 'send-orders',
        component: () => import(/* webpackChunkName: 'help' */'@/components/_help/HelpSendOrders')
      }, {
        path: 'tasks',
        component: () => import(/* webpackChunkName: 'help' */'@/components/_help/HelpTasks')
      }, {
        path: 'finance',
        component: () => import(/* webpackChunkName: 'help' */'@/components/_help/HelpFinance')
      }, {
        path: 'other',
        component: () => import(/* webpackChunkName: 'help' */'@/components/_help/HelpOther')
      }]
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('@/components/Report')
    },
    {
      path: '/pre_charges',
      name: 'pre-charges',
      component: () => import('@/components/PreCharges')
    },
    {
      path: '/order_incomes',
      name: 'order-incomes',
      component: () => import('@/components/OrderIncomes')
    },
    {
      path: '/yinjie',
      name: 'yinjie',
      component: () => import('@/components/yinjie')
    }
  ]
})

router.beforeEach(function (to, from, next) {
  let auth = true

  if (to.matched.some(record => record.meta.auth === false)) {
    auth = false
  }

  if (auth && !hasLogin()) {
    // if route requires auth and user isn't authenticated
    next({path: '/login', query: {url: to.fullPath}})
  } else {
    next()
  }
})

export default router
